import { useTranslations } from "contexts/LocalizationContext/hooks";
import { Grid } from "modules/common/components/Grid";
import config from "config/config";
import { useModal } from "contexts/ModalContext";
import { trackUAEvent, trackCustomEvent } from "utils/tracking";
import { CardsContainer } from "components/Cards";
import { Box, Flex, Text, Heading, Button } from "@chakra-ui/react";
import { Modal } from "../../Modal/Modal";
import { SHARE_NOW_CUSTOMERS_SAY_EVENT_UA, SHARE_NOW_CUSTOMERS_SAY_EVENT } from "../../utils/trackingConsts";
import { HOW_IT_WORKS_ANCHOR } from "../../utils/consts";
import type { HowItWorksProps } from "./HowItWorks.d";

export const HowItWorks = ({ preheader, title, buttonText, cards }: HowItWorksProps) => {
  const translations = useTranslations();
  const { openModal } = useModal();

  const clickHandler = () => {
    openModal(<Modal />, "md");
    trackUAEvent(SHARE_NOW_CUSTOMERS_SAY_EVENT_UA);
    trackCustomEvent(SHARE_NOW_CUSTOMERS_SAY_EVENT);
  };

  return (
    <Box
      bgColor="greyscale.300"
      bgRepeat="no-repeat"
      bgImage={{
        base: "none",
        lg: `url(${config.staticUrl}/i/airhelp-plus/ahplus-landing-page-bg-fragment-triangles-01.svg)`,
      }}
      py={{ base: 14, lg: 28 }}
      bgPosition="left -30%"
    >
      <Grid id={HOW_IT_WORKS_ANCHOR} mb={0}>
        <Flex gridColumn={{ base: "span 1", md: "span 12" }} flexDir="column">
          <Text
            color="primary.500"
            letterSpacing="1.5px"
            fontSize="xs"
            textTransform="uppercase"
            fontWeight="bold"
            pb={2}
          >
            {preheader}
          </Text>
          <Flex direction={{ base: "column", xl: "row" }} flexWrap="wrap">
            <Heading variant="h2" as="h2" pb={2}>
              {title}
            </Heading>
            <Button
              p={0}
              bg="transparent"
              _hover={{ bg: "transperent" }}
              variant="subtle"
              alignSelf={{ base: "flex-start", xl: "flex-end" }}
              fontSize="lg"
              mb={{ base: 10, xl: 14 }}
              ml={{ base: 0, xl: "auto" }}
              onClick={clickHandler}
              fontWeight="normal"
            >
              {buttonText || translations("button_share_now")} &rarr;
            </Button>
          </Flex>
          {cards && Boolean(cards.length) && (
            <CardsContainer cards={cards?.length && cards} cardsHeightDesktop="330px" />
          )}
        </Flex>
      </Grid>
    </Box>
  );
};
